import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'BluekraftMed';
const BASE_TITLE = `${SITE_NAME} - Healthcare Staffing Solutions`;
const DEFAULT_DESCRIPTION = 'Leading provider of healthcare staffing services dedicated to excellence in patient care.';

/**
 * PageMeta sets per-route document title and meta description for SEO.
 * Each page should use this so crawlers and social shares get unique titles/descriptions.
 */
function PageMeta({ title, description = DEFAULT_DESCRIPTION, path = '' }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : BASE_TITLE;
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://bluekraftmed.com';
  const canonical = `${origin}${path || '/'}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
    </Helmet>
  );
}

export default PageMeta;
